const DEFAULT_MORE_LABEL = 'See more';
const DEFAULT_LESS_LABEL = 'See less';

const readMoreByHeight = (maxHeight, selector, moreLabel = DEFAULT_MORE_LABEL, lessLabel = DEFAULT_LESS_LABEL) => {
  $(function () {
    const allReadMoreContents = $(selector);

    allReadMoreContents.each(function () {
      const content = $(this);
      const text = content.children('.rm-text');
      const btn = content.children('.rm-btn');
      const gradient = content.children('.rm-gradient');

      if (text.innerHeight() > maxHeight) {
        text.css('height', maxHeight);
        btn.removeClass('rm-initially-hidden');
        btn.text(moreLabel);
        gradient.removeClass('rm-initially-hidden');
      } else {
        content.removeClass('rm-content-hidden');
        content.addClass('rm-content-visible');
      }

      btn.on('click', function () {
        const self = $(this);
        let btnLabel = self.text();

        if (btnLabel === moreLabel) {
          btnLabel = lessLabel;
          text.css('height', 'auto');
          content.removeClass('rm-content-hidden');
          content.addClass('rm-content-visible');
        } else {
          btnLabel = moreLabel;
          text.css('height', maxHeight);
          content.removeClass('rm-content-visible');
          content.addClass('rm-content-hidden');
        }

        self.text(btnLabel);
      });
    });
  });
};

export default readMoreByHeight;
